<div class="w-[500px]">
  <div class="flex items-center justify-between mb-4">
    <em
      class="material-symbols-outlined icon-regular cursor-pointer"
      [ngClass]="getNavigationClass('prev')"
      (click)="goToPreviousYear()">
      arrow_back
    </em>
    <span class="sh2 text-gray-1000 mx-2">{{ selectedYear }}</span>
    <em
      class="material-symbols-outlined icon-regular cursor-pointer"
      [ngClass]="getNavigationClass('next')"
      (click)="goToNextYear()">
      arrow_forward
    </em>
  </div>

  <div class="grid" [ngClass]="getGridClass()">
    @for (period of periods; track period; let i = $index) {
      <div
        class="b1 p-4 rounded-md text-center cursor-pointer border-2 border-solid"
        [ngClass]="getPeriodClass(i)"
        (click)="!isPeriodDisabled(i) && onPeriodSelect(i)">
        {{ period }}
      </div>
    }
  </div>
</div>
